export default __webpack_public_path__ + "static/media/path-2.5daa365c.svg";